var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27614 6.99984L6 9.27598L4.39052 7.6665L5.33333 6.72369L6 7.39036L7.33333 6.05703L8.27614 6.99984Z",
    fill: "#2D67D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6.99984H11.3333V8.33317H8.66667V6.99984Z",
    fill: "#2D67D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27614 10.3332L6 12.6093L4.39052 10.9998L5.33333 10.057L6 10.7237L7.33333 9.39036L8.27614 10.3332Z",
    fill: "#2D67D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 10.3332H11.3333V11.6665H8.66667V10.3332Z",
    fill: "#2D67D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72386 0.666504H10.2761L11.3333 1.72369V1.99984H14V15.3332H2V1.99984H4.66667V1.72369L5.72386 0.666504ZM4.66667 3.33317H3.33333V13.9998H12.6667V3.33317H11.3333V4.6665H4.66667V3.33317ZM10 2.27598L9.72386 1.99984H6.27614L6 2.27598V3.33317H10V2.27598Z",
    fill: "#2D67D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.6fde7bdbd7500bc768de7a5bdc02d65b.svg";
export { ForwardRef as ReactComponent };